import { ComponentType, useEffect, useState } from "react";
import {
  IconAddBookmark,
  IconBookmark,
  IconBookmarked,
  IconDeleteBookmark,
  IconProps,
} from "../icons";
import styles from "./PageBookmark.module.scss";
import classNames from "classnames";
import { ButtonIcon } from "../buttons";

export interface IPageBookmarkProps {
  /** Is the page currently bookmarked? */
  bookmarked: boolean;
  /** Function to call to edit the status of the bookmark. */
  onClick: () => Promise<void>;
}

export const PageBookmark = ({ bookmarked, onClick }: IPageBookmarkProps) => {
  const [isBookmarked, setBookmarked] = useState<boolean>(bookmarked);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  useEffect(() => {
    setBookmarked(bookmarked);
  }, [bookmarked]);

  async function handlePageBookmarkClick(): Promise<void> {
    await onClick().then(() => {
      setBookmarked(!isBookmarked);
    });
  }

  const handleOnMouseEnter = () => {
    setIsHovered(true);
  };

  const handleOnMouseLeave = () => {
    setIsHovered(false);
  };

  let IconToDisplay: ComponentType<IconProps> = IconBookmark;
  if (isBookmarked) {
    IconToDisplay = isHovered ? IconDeleteBookmark : IconBookmarked;
  } else {
    IconToDisplay = isHovered ? IconAddBookmark : IconBookmark;
  }

  const classes = classNames(styles.removeBorderOnHover, styles.iconSize);

  return (
    <span onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
      <ButtonIcon
        className={classes}
        aria-label={isBookmarked ? "Remove bookmark" : "Add bookmark"}
        onClick={handlePageBookmarkClick}
      >
        <IconToDisplay />
      </ButtonIcon>
    </span>
  );
};
